/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Copy_To_BInputs */



/**
* | output |
* | --- |
* | "Copy to B" |
*
* @param {Compare_Event_Groups_Copy_To_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_copy_to_b = /** @type {((inputs?: Compare_Event_Groups_Copy_To_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Copy_To_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier vers B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopie an B")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia su B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копия в B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar a B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制到 B")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Bにコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("B में कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cópia para B")
	return /** @type {LocalizedString} */ ("Copy to B")
});